@if (isPreviewMode) {
    <div class="preview-container">
        <div>You are on Preview Mode</div>
        <a (click)="exitPreviewMode()" tabindex="0" (keypress)="exitPreviewMode()">Exit</a>
    </div>
}

